import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { ApplicationService } from '../../../lib/services/application.service';

@Component({
    selector: 'app-cookie',
    templateUrl: './cookie.component.html',
    styleUrls: ['./cookie.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class CookieComponent implements OnInit {
  private applicationService = inject(ApplicationService);

  applicationName: string

  constructor() {
    this.applicationName = this.applicationService.getApplicationName()
  }

  ngOnInit(): void {
  }

}
